import axios from "axios";

const request = axios.create({
  // baseURL: process.env.REACT_APP_BACKEND_SERVER,
  baseURL:"https://api.snazzy.in",
  withCredentials: true,
});
export default request;
